// The shell standard's tooltip, as in api-core: 6px from its control, fading in place instead of jumping.
// The look is in src/css/_shell-tooltip.scss.
export const TOOLTIP_OFFSET = [6, 6]

// Changes QTooltip's prop defaults, so it must run before any tooltip mounts. A tooltip that passes its own
// offset or transition keeps it.
export function applyTooltipDefaults (QTooltip) {
  const props = QTooltip.options.props

  props.offset.default = () => [...TOOLTIP_OFFSET]
  props.transitionShow.default = 'fade'
  props.transitionHide.default = 'fade'
}
